import { useEffect, useState } from 'react';

interface PositionAndSize {
  relativeX: number;
  relativeY: number;
  width: number;
  height: number;
}

function useElementPositionAndSize(element: HTMLElement | null): PositionAndSize {
  const [positionAndSize, setPositionAndSize] = useState<PositionAndSize>({ relativeX: 0, relativeY: 0, width: 0, height: 0 });

  useEffect(
    () => {
      if (!element)
        return;

      // init values
      const initialClientRect = element.getBoundingClientRect();

      setPositionAndSize({
        relativeX: element.offsetLeft,
        relativeY: element.offsetTop,
        width: initialClientRect.width,
        height: initialClientRect.height,
      });

      // setup event listener
      const updatePositionAndSize = (entries: ResizeObserverEntry[]) => setPositionAndSize({
        relativeX: entries[0].contentRect.x,
        relativeY: entries[0].contentRect.y,
        width: entries[0].contentRect.width,
        height: entries[0].contentRect.height,
      });

      const observer = new ResizeObserver(updatePositionAndSize);
      observer.observe(element);

      return () => observer.disconnect();
    },
    [element],
  );

  return positionAndSize;
}

export default useElementPositionAndSize;